import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { AlertTriangle } from "lucide-react";

interface DeleteDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  documentName: string;
  isPending?: boolean;
}

export default function DeleteDocumentModal({
  isOpen,
  onClose,
  onDelete,
  documentName,
  isPending = false,
}: DeleteDocumentModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[500px] rounded-xl">
        <DialogHeader>
          <p className="text-base font-semibold text-[#051912]">
            Delete Document
          </p>
          <Separator />
          <DialogDescription className="text-black-7 pt-2" asChild>
            <div>
              <div className="flex items-start gap-3 p-3 bg-red-50 border border-red-200 rounded-lg mb-3">
                <AlertTriangle
                  size={18}
                  className="text-red-600 shrink-0 mt-0.5"
                />
                <div className="text-sm text-red-800">
                  <p className="font-medium mb-1">
                    This action cannot be undone
                  </p>
                  <p className="text-xs text-red-700 leading-relaxed">
                    Deleting{" "}
                    <span className="font-semibold">
                      {documentName || "this document"}
                    </span>{" "}
                    will permanently remove it from your system.
                  </p>
                </div>
              </div>
            </div>
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="mt-6 flex justify-end gap-2">
          <Button variant="cancel" onClick={onClose} disabled={isPending}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onDelete}
            disabled={isPending}
            className="bg-red-600 hover:bg-red-700"
          >
            {isPending ? "Deleting..." : "Delete Document"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
